import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { useCallback } from "react";
import { useTranslations } from "use-intl";
import { ActionTimeline, ActionTimelineError, ActionTimelineSkeleton } from "../../../../../components/ActionTimeline";
import { getCollectionSweepQuoteError } from "../../../../../components/CollectionSweepQuoteReceipt/getCollectionSweepQuoteError";
import { FlowActions } from "../../../../../stores/flowStore";
import { useActionErrors } from "../../../../hooks/useErrors";
import { useCollectionSweepQuery } from "../../hooks/useCollectionSweepQuery";
import { CollectionSweepFlowTimeline_quoteFragment } from "./CollectionSweepTimeline.fragment";
function getPaymentAsset(quote) {
  if (quote.quote.__typename === "CollectionSweepQuoteNotFound") {
    return {
      chain: quote.collection.chain.identifier,
      address: "0x0000000000000000000000000000000000000000"
    };
  }
  const itemQuote = quote.quote.itemQuotes[0];
  return {
    chain: itemQuote.pricePerItem.token.chain.identifier,
    address: itemQuote.pricePerItem.token.address
  };
}
export function CollectionSweepTimeline(t0) {
  const $ = _c(21);
  const {
    collectionSlug,
    maxAmountOfItems,
    maxPricePerItem,
    recipient,
    quote: quoteKey,
    onAllActionsCompleted: onAllActionsCompletedProp
  } = t0;
  const t = useTranslations("wallet.CollectionSweepTimeline");
  const quote = readFragment(CollectionSweepFlowTimeline_quoteFragment, quoteKey);
  const paymentAsset = getPaymentAsset(quote);
  const t1 = String(maxPricePerItem);
  let t2;
  if ($[0] !== collectionSlug || $[1] !== maxAmountOfItems || $[2] !== paymentAsset || $[3] !== recipient || $[4] !== t1) {
    t2 = {
      paymentAsset,
      collectionSlug,
      maxAmountOfItems,
      maxPricePerItem: t1,
      recipient
    };
    $[0] = collectionSlug;
    $[1] = maxAmountOfItems;
    $[2] = paymentAsset;
    $[3] = recipient;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    actions,
    error,
    fetching,
    refetch
  } = useCollectionSweepQuery(t2);
  let t3;
  if ($[6] !== onAllActionsCompletedProp) {
    t3 = (response, receiptTransactions) => {
      if (response.action === "TRANSACTION") {
        FlowActions.setFlowField("transactionIdentifier", {
          chain: response.transactionIdentifier.chain,
          transactionHash: response.transactionIdentifier.hash
        });
      }
      onAllActionsCompletedProp?.(response, receiptTransactions);
    };
    $[6] = onAllActionsCompletedProp;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onAllActionsCompleted = t3;
  const actionError = useActionErrors();
  const quoteError = getCollectionSweepQuoteError(quote.quote);
  if (quoteError) {
    return null;
  }
  if (fetching) {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ActionTimelineSkeleton count={1} />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (error) {
    let t4;
    if ($[9] !== t) {
      t4 = t("error");
      $[9] = t;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== refetch || $[12] !== t4) {
      t5 = <ActionTimelineError message={t4} onRetry={refetch} />;
      $[11] = refetch;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  if (actionError) {
    let t4;
    if ($[14] !== actionError || $[15] !== refetch) {
      t4 = <ActionTimelineError message={actionError} onRetry={refetch} />;
      $[14] = actionError;
      $[15] = refetch;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    return t4;
  }
  let t4;
  if ($[17] !== actions || $[18] !== onAllActionsCompleted || $[19] !== refetch) {
    t4 = <ActionTimeline actions={actions} onAllActionsCompleted={onAllActionsCompleted} onReload={refetch} />;
    $[17] = actions;
    $[18] = onAllActionsCompleted;
    $[19] = refetch;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}